import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[invdUptoThreeDecimal]',
})
export class UptoThreeDecimalDirective {
  @HostListener('keypress', ['$event']) onKeyDown(event) {
    if (!this.restrictNumeric(event)) {
      event.preventDefault();
    }
  }

  private restrictNumeric(e: any): boolean {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which === 46) {
      if (e.target.value.includes('.')) {
        return false;
      } else {
        if (e.target.value.length - e.target.selectionEnd > 3) {
          return false;
        } else {
          return true;
        }
      }
    }

    if (e.which < 33) {
      return true;
    }

    if (e.target.value.includes('.')) {
      const idx = e.target.value.indexOf('.');
      if (e.target.value.length - idx > 3) {
        if (e.target.value.length - e.target.selectionEnd < 4) {
          return false;
        } else {
          input = String.fromCharCode(e.which);
          return !!/[\d\s.]/.test(input);
        }
      } else {
        input = String.fromCharCode(e.which);
        return !!/[\d\s]/.test(input);
      }
    } else {
      input = String.fromCharCode(e.which);
      return !!/[\d\s]/.test(input);
    }
  }
}
